<!-- TEMPLATE GLOBAL DES BOUTONS -->
<div fxLayout=”row” fxLayoutAlign="end">
  <div fxLayout=”row” fxLayoutAlign="start">
    <div *ngIf="isManual">
      <ng-container *ngTemplateOutlet="IsManualButtonsPDF"></ng-container>
    </div>
  </div>
  <div fxLayout=”row” fxLayoutAlign="end">
    <div *ngIf="this.hasAdministrationGrant">
      <ng-container *ngTemplateOutlet="logInvisible" class="invisibleLog">
      </ng-container>
    </div>
    <div *ngIf="isControl" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isControlInvoiceButtons"></ng-container>
    </div>
    <div *ngIf="isDispatchedInvoice" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isDispatchedInvoiceButtons"></ng-container>
    </div>
    <div *ngIf="isSearchDetail" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isSearchDetailButtons"></ng-container>
    </div>
    <div *ngIf="isRejectedInvoice" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isRejectedInvoiceButtons"></ng-container>
    </div>
    <div *ngIf="isPendingForWorkflowCompletionVoucher" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isPendingForWorkflowCompletionVoucherButtons"></ng-container>
    </div>
    <div *ngIf="isPendingForWorkflowCompletionPromotion" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isPendingForWorkflowCompletionPromotionButtons"></ng-container>
    </div>
    <div *ngIf="isPendingForVoucherValidation" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isPendingForVoucherValidationButtons"></ng-container>
    </div>
    <div *ngIf="isInQualificationPipeline" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isQualificationPipelineButtons"></ng-container>
    </div>
    <div *ngIf="IsInjection" class="buttons-container">
      <ng-container *ngTemplateOutlet="IsInjectionButtons"></ng-container>
    </div>
    <div *ngIf="isManual" class="buttons-container">
      <ng-container *ngTemplateOutlet="IsManualButtons"></ng-container>
    </div>
    <div *ngIf="isWaitingVoucher" class="buttons-container">
      <div class="btnSpacerCol" *ngIf="showGoBackDetailsButton">
        <ng-container *ngTemplateOutlet="goBackDetails"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="isWaitingVoucherInvoiceButtons"></ng-container>
    </div>
  </div>
</div>

<!-- FACTURE A TRAITER -->
<ng-template #isDispatchedInvoiceButtons>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="addAttachment"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="forward"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="cancelResend"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="invoiceForm && !hidePDFViewerButtonForPPR">
    <ng-container *ngTemplateOutlet="modifyInvoice"></ng-container>
  </div>
  <ng-container ngIf="!isWaitingVoucher" *ngTemplateOutlet="sendToWaitingStatusButtonDispatched"></ng-container>
  <div class="btnSpacerCol" *ngIf="invoiceForm && !hidePDFViewerButtonForPPR">
    <button mat-stroked-button class="currentBtnColor" matTooltip="Traiter la facture" (click)="onProcess()" [disabled]="isDispatchedProcessDisabled">
      <mat-icon>check_circle_outline</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Traiter</span>
    </button>
  </div>
  <div class="btnSpacerCol" *ngIf="!invoiceForm && !hidePDFViewerButtonForPPR">
    <button mat-stroked-button class="currentBtnColor" matTooltip="Traiter la facture" (click)="onProcess()" [disabled]="!canProcess || canWaitInvoiceInternal || !canProcessInvoiceInternal">
      <mat-icon>check_circle_outline</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Traiter</span>
    </button>
  </div>
</ng-template>

<!-- FACTURES A CONTROLER -->
<ng-template #isControlInvoiceButtons>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="addAttachment"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="forward"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="cancelResend"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="invoiceForm">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer la facture" (click)="onSubmit()" [disabled]="!(isInvoiceFormUpdated && invoiceForm.valid)">
      <mat-icon>save</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Enregistrer</span>
    </button>
  </div>
  <ng-container *ngTemplateOutlet="sendToWaitingStatusButtonControl"></ng-container>

  <div class="btnSpacerCol" *ngIf="invoiceForm">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Contrôler la facture" (click)="checkInvoice()"
      [disabled]="isEmptyEvaluaCompanyName || (isInvoiceFormUpdated && hasMandatoryFieldChanged) || !invoiceForm.valid">
      <mat-icon>assignment_turned_in</mat-icon>
      <span fxHide fxShow.gt-lg *ngIf="!hasMandatoryFieldChanged">Contrôler</span>
      <span class="long-btn-span large currentBtnDetailColor" Hide fxShow.gt-lg *ngIf="hasMandatoryFieldChanged">Modifier et contrôler</span>
    </button>
  </div>

  <div class="btnSpacerCol" *ngIf="!invoiceForm">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Contrôler la facture" (click)="checkInvoice()" [disabled]="isEmptyEvaluaCompanyName || !asRefOne">
      <mat-icon>assignment_turned_in</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Contrôler</span>
    </button>
  </div>
</ng-template>

<!-- FACTURES EN ATTENTE -->
<ng-template #isWaitingVoucherInvoiceButtons>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="addAttachment"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="cancelResend"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="ReturnOperationnal"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="modifyInvoiceWaiting"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="!hideInvoicePPRLogErrorHistory">
    <ng-container *ngTemplateOutlet="InvoicePPRLogErrorHistory"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="isInErrorPPRState">
    <ng-container *ngTemplateOutlet="InvoicePPRReSend"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="!invoiceForm && !isInErrorPPRState">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Traiter la facture" (click)="onProcess()" [disabled]="isDispatchedProcessDisabled">
      <mat-icon>check_circle_outline</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Traiter</span>
    </button>
  </div>
  <!-- Operational group -->
  <ng-container *ngIf="!isInErrorPPRState && !this.isToControlInWaiting">
    <div class="btnSpacerCol" *ngIf="invoiceForm && !canValidateVoucher">
      <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Traiter la facture" (click)="onProcess()" [disabled]="isDispatchedProcessDisabled">
        <mat-icon>check_circle_outline</mat-icon>
        <span fxHide fxShow.gt-lg *ngIf="!hasMandatoryFieldChanged" class="currentBtnDetailColor">Traiter</span>
        <span class="long-btn-span large" fxHide fxShow.gt-lg *ngIf="hasMandatoryFieldChanged">Enregistrer et traiter</span>
      </button>
    </div>
    <div class="btnSpacerCol" *ngIf="invoiceForm && canValidateVoucher">
      <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Traiter le bon à payer" (click)="onProcess()"
        [disabled]="!canProcess || canWaitInvoiceInternal || !canProcessInvoiceInternal">
        <mat-icon>check_circle_outline</mat-icon>
        <span fxHide fxShow.gt-lg *ngIf="!hasMandatoryFieldChanged" class="currentBtnDetailColor">Traiter</span>
        <span class="long-btn-span large" fxHide fxShow.gt-lg *ngIf="hasMandatoryFieldChanged">Enregistrer et traiter</span>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!isInErrorPPRState && this.isToControlInWaiting">
    <div class="btnSpacerCol" *ngIf="invoiceForm">
      <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Contrôler la facture" (click)="checkInvoice()"
        [disabled]="isEmptyEvaluaCompanyName || (isInvoiceFormUpdated && hasMandatoryFieldChanged) || !invoiceForm.valid">
        <mat-icon>assignment_turned_in</mat-icon>
        <span fxHide fxShow.gt-lg *ngIf="!hasMandatoryFieldChanged">Contrôler</span>
        <span class="long-btn-span large currentBtnDetailColor" fxHide fxShow.gt-lg *ngIf="hasMandatoryFieldChanged">Modifier et contrôler</span>
      </button>
    </div>

    <div class="btnSpacerCol" *ngIf="!invoiceForm">
      <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Contrôler la facture" (click)="checkInvoice()" [disabled]="isEmptyEvaluaCompanyName || !asRefOne">
        <mat-icon>assignment_turned_in</mat-icon>
        <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Contrôler</span>
      </button>
    </div>
  </ng-container>

</ng-template>

<!-- FACTURES EN REJET -->
<ng-template #isRejectedInvoiceButtons>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <ng-container *ngIf="!isInQualificationPipeline">
    <div class="btnSpacerCol">
      <ng-container *ngTemplateOutlet="cancelResend"></ng-container>
    </div>
    <div class="btnSpacerCol" *ngIf="isDuplicateInvoice">
      <ng-container *ngTemplateOutlet="archiveInvoice"></ng-container>
    </div>
    <div class="btnSpacerCol" *ngIf="isDuplicateInvoice">
      <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Réinitialiser la facture" (click)="onReset()">
        <mat-icon>restart_alt</mat-icon>
        <span fxHide fxShow.gt-lg>Réinitialiser</span>
      </button>
    </div>
    <div class="btnSpacerCol" *ngIf="!isPickedByMe">
      <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Prendre en charge la facture" (click)="onPick()">
        <mat-icon>check_circle_outline</mat-icon>
        <span class="long-btn-span large currentBtnDetailColor" fxHide fxShow.gt-lg>Prendre en charge</span>
      </button>
    </div>
    <div class="btnSpacerCol" *ngIf="isPickedByMe">
      <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Relâcher la facture" (click)="onUnpick()">
        <mat-icon>remove_circle_outline</mat-icon>
        <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Relâcher</span>
      </button>
    </div>
    <div class="btnSpacerCol" *ngIf="!isNonCompliantInvoice && !isDuplicateInvoice">
      <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Affecter la facture à un groupe" (click)="onForward()">
        <mat-icon>groups</mat-icon>
        <span fxHide fxShow.gt-lg>Affecter</span>
      </button>
    </div>
    <div class="btnSpacerCol" *ngIf="invoiceForm && !isDuplicateInvoice">
      <ng-container *ngTemplateOutlet="modifyInvoice"></ng-container>
    </div>
  </ng-container>
</ng-template>

<!-- FACTURE A VALIDER -->
<ng-template #isPendingForWorkflowCompletionVoucherButtons>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="goBackDetailsSearch"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="showValidationButton">
    <ng-container *ngTemplateOutlet="validateWorkflow"></ng-container>
  </div>
</ng-template>

<!-- FACTURE A VALIDER PROMOTION-->
<ng-template #isPendingForWorkflowCompletionPromotionButtons>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="goBackDetailsSearch"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="showComplaintPromotionButton && !isComplaintByMe">
    <ng-container *ngTemplateOutlet="complaintInvoice"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="showComplaintPromotionButton && isComplaintByMe">
    <ng-container *ngTemplateOutlet="notComplaintInvoice"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="showValidationButton">
    <ng-container *ngTemplateOutlet="validateWorkflowPromotion"></ng-container>
  </div>
</ng-template>

<!-- FACTURE A COMPTABILISER -->
<ng-template #isPendingForVoucherValidationButtons>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="goBackDetailsSearch"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="canValidateVoucher">
    <ng-container *ngTemplateOutlet="cancelResend"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="canCancelProcess && canValidateVoucher">
    <ng-container *ngTemplateOutlet="cancelValidation"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="invoiceForm && canValidateVoucher">
    <ng-container *ngTemplateOutlet="modifyInvoice"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="canValidateVoucher">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Traiter le bon à payer" (click)="onVoucherValidation()" [disabled]="!canProcess">
      <mat-icon>check_circle_outline</mat-icon>
      <span fxHide fxShow.gt-lg *ngIf="!isInvoiceFormUpdated">Traiter</span>
      <span class="long-btn-span large currentBtnDetailColor" fxHide fxShow.gt-lg *ngIf="isInvoiceFormUpdated">Enregistrer et traiter</span>
    </button>
  </div>
</ng-template>

<!-- RECHERCHE FACTURE-->
<ng-template #isSearchDetailButtons>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="goBackDetailsSearch"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="(!this.invoice.IsPPR && canCancelProcess && !isInQualificationPipeline && !canCancelProcessPromotion) || (this.invoice.IsPPR && this.isInProcessedStateState)">
    <ng-container *ngTemplateOutlet="cancelValidation"></ng-container>
  </div>
  <div class="btnSpacerCol" *ngIf="canCancelProcessPromotion">
    <ng-container *ngTemplateOutlet="cancelInvoicePromotion"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="traceabilityDetail"></ng-container>
  </div>
</ng-template>

<!-- TEMPLATE BOUTONS -->
<ng-template #log>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Log" (click)="findInvalidControls()">
    <mat-icon>policy</mat-icon>
    <span fxHide fxShow.gt-lg>Log</span>
  </button>
</ng-template>

<ng-template #logInvisible>
  <button color="primary" class="invisibleLog" (click)="findInvalidControls()">
  </button>
</ng-template>

<ng-template #goBackDetails>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Retour" (click)="goBackToDetails()">
    <mat-icon>keyboard_return</mat-icon>
    <span fxHide fxShow.gt-lg>Retour</span>
  </button>
</ng-template>

<ng-template #goBackDetailsSearch>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Retour" (click)="goBackToInvoiceList()">
    <mat-icon>keyboard_return</mat-icon>
    <span class="long-btn-span" fxHide fxShow.gt-lg>Retour à la liste</span>
  </button>
</ng-template>

<ng-template #pdfViewer>
  <a mat-stroked-button color="primary" class="currentBtn" matTooltip="Ouvrir la facture dans un lecteur pdf" target="_blanck" [routerLink]="['/invoices', invoiceViewType, 'detail-pdf', invoice.Id]">
    <mat-icon>picture_as_pdf</mat-icon>
    <span class="long-btn-span" fxHide fxShow.gt-lg>Voir la facture</span>
  </a>
</ng-template>

<ng-template #IsInjectionButtons>
  <div class="btnSpacerCol">
    <a mat-stroked-button color="primary" class="currentBtn" matTooltip="Ouvrir la facture dans un lecteur pdf" target="_blanck"
      [routerLink]="['/analysis/missing-invoice-numbers/detail-pdf/', injection.ImportMissingInvoiceNumberDocumentId]">
      <mat-icon>picture_as_pdf</mat-icon>
      <span class="long-btn-span" fxHide fxShow.gt-lg>Voir la facture</span>
    </a>
  </div>
  <div class="btnSpacerCol">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer la facture" (click)="onInject()" [disabled]="!invoiceForm.valid">
      <mat-icon>save</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Enregistrer</span>
    </button>
  </div>
</ng-template>

<ng-template #IsManualButtons>
  <div class="btnSpacerCol">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Annuler la création de la facture" [routerLink]="['/invoices/dispatched']">
      <mat-icon>cancel</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Annuler</span>
    </button>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="addAttachmentCreateInvoice"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer la facture" (click)="onManualCreate()" [disabled]="isSaveManualDisabled">
      <mat-icon>save</mat-icon>
      <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Enregistrer</span>
    </button>
  </div>
</ng-template>

<ng-template #IsManualButtonsPDF>
  <div fxFlex="100" fxFlex.gt-sm="100" fxLayoutAlign="center" fxLayoutGap="10px">
    <div class="error" *ngIf="!isPDFOnManualSet">
      <mat-icon class="error" matTooltip="Attention : il faut obligatoirement joindre une facture PDF.">
        report_problem</mat-icon>
    </div>
    <div fxLayoutAlign="start center" *ngIf="!isPDFOnManualSet">
      <span><strong>Attention : </strong>il faut obligatoirement joindre une facture PDF.</span>
    </div>
    <div fxLayoutAlign="start center" *ngIf="isPDFOnManualSet">
      <strong>Nom de la facture : </strong> {{this.filename}}
    </div>
  </div>
</ng-template>

<ng-template #addAttachmentCreateInvoice>
  <input type="file" #file id="fileDropRef" multiple hidden [accept]="'.pdf'" (change)="onFilesChange($event.target.files)" />
  <button color="primary" mat-stroked-button [class]="this.isPDFOnManualSet ? 'successBtn' : 'errorBtn'" matTooltip="Joindre la facture" (click)="file.click()">
    <mat-icon>attach_file</mat-icon>
    <span class="long-btn-span large" fxHide fxShow.gt-lg>Joindre la facture</span>
  </button>
</ng-template>

<ng-template #InvoicePPRLogErrorHistory>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Historique des retours PPR" (click)="onInvoicePPRLogErrorHistory()">
    <mat-icon>assignment_late</mat-icon>
    <span class="long-btn-span" fxHide fxShow.gt-lg>Historique PPR</span>
  </button>
</ng-template>

<ng-template #InvoicePPRReSend>
  <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Renvoyer la facture à PPR" (click)="onPPRReSend()" [disabled]="isDispatchedProcessDisabled">
    <mat-icon>send</mat-icon>
    <span class="long-btn-span really-large currentBtnDetailColor" fxHide fxShow.gt-lg>Renvoyer la facture à PPR</span>
  </button>
</ng-template>

<ng-template #isQualificationPipelineButtons>
  <div class="btnSpacerCol" *ngIf="!hidePDFViewerButton">
    <ng-container *ngTemplateOutlet="pdfViewer"></ng-container>
  </div>
  <div class="btnSpacerCol">
    <ng-container *ngTemplateOutlet="traceabilityDetail"></ng-container>
  </div>
</ng-template>

<ng-template #addAttachment>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Joindre un document à la facture" (click)="onAttach()">
    <mat-icon matPrefix>attach_file</mat-icon>
    <span class="long-btn-span large" fxHide fxShow.gt-lg>Joindre un document</span>
  </button>
</ng-template>

<ng-template #forward>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Transférer la facture à un autre groupe" (click)="onForward()">
    <mat-icon>swap_horiz</mat-icon>
    <span fxHide fxShow.gt-lg>Transférer</span>
  </button>
</ng-template>

<ng-template #cancelResend>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Annuler et renvoyer la facture" (click)="onSendBack(1)">
    <mat-icon>cached</mat-icon>
    <span class="long-btn-span large" fxHide fxShow.gt-lg>Annuler et renvoyer</span>
  </button>
</ng-template>

<ng-template #modifyInvoice>
  <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer la facture" (click)="onSubmit()" [disabled]="isDispatchedModifyDisabled">
    <mat-icon>border_color</mat-icon>
    <span fxHide fxShow.gt-lg>Enregistrer</span>
  </button>
</ng-template>

<ng-template #archiveInvoice>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Archiver la facture" (click)="onArchive()">
    <mat-icon>archive</mat-icon>
    <span fxHide fxShow.gt-lg>Archiver</span>
  </button>
</ng-template>

<ng-template #validateWorkflow>
  <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Valider le bon à payer" (click)="onWorkflowStageValidation()">
    <mat-icon>check_circle_outline</mat-icon>
    <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Valider
    </span>
  </button>
</ng-template>

<ng-template #modifyInvoiceWorkflow>
  <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer la facture" (click)="onUpdateInvoiceWorkflow()" [disabled]="!(isInvoiceFormUpdated && invoiceForm.valid)">
    <mat-icon>border_color</mat-icon>
    <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Enregistrer</span>
  </button>
</ng-template>

<ng-template #modifyInvoiceWaiting>
  <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer la facture" (click)="onUpdateInvoiceWaiting()"
    [disabled]="isSaveWaitingDisabled || !isDispatchedProcessDisabled">
    <mat-icon>border_color</mat-icon>
    <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Enregistrer</span>
  </button>
</ng-template>

<ng-template #validateWorkflowPromotion>
  <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Valider le bon à payer" (click)="onWorkflowStageValidation()" [disabled]="isComplaint || isInvalideCtrlAmount">
    <mat-icon>check_circle_outline</mat-icon>
    <span fxHide fxShow.gt-lg class="currentBtnDetailColor">Valider</span>
  </button>
</ng-template>

<ng-template #traceabilityDetail>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Afficher les éléments de traçabilité" (click)="onTraceabilityDetail()">
    <mat-icon>list</mat-icon>
    <span class="long-btn-span large" fxHide fxShow.gt-lg>Eléments de traçabilité</span>
  </button>
</ng-template>

<ng-template #cancelValidation>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Annuler le traitement" (click)="onCancelProcess()">
    <mat-icon>cancel</mat-icon>
    <span class="long-btn-span" style="width: 260px" fxHide fxShow.gt-lg>Annuler la validation du traitement</span>
  </button>
</ng-template>

<ng-template #cancelInvoicePromotion>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Annuler la facture / Situation de travaux après la validation du workflow Niveau 3" (click)="onCancelProcessPromotion()">
    <mat-icon>cancel</mat-icon>
    <span fxHide fxShow.gt-lg>Annuler la facture</span>
  </button>
</ng-template>

<ng-template #complaintInvoice>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Mise en litige" (click)="onComplaint()">
    <mat-icon>assignment_return</mat-icon>
    <span class="long-btn-span" fxHide fxShow.gt-lg>Mise en litige</span>
  </button>
</ng-template>

<ng-template #notComplaintInvoice>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Relâcher" (click)="onUncomplaint()">
    <mat-icon>assignment_returned</mat-icon>
    <span fxHide fxShow.gt-lg>Relâcher</span>
  </button>
</ng-template>

<ng-template #ReturnOperationnal>
  <button color="primary" mat-stroked-button class="currentBtn" matTooltip="Renvoyer à l'operationnel" (click)="onReturnOperationnal()">
    <mat-icon>assignment_return</mat-icon>
    <span class="long-btn-span really-large" fxHide fxShow.gt-lg>Renvoyer à l'operationnel</span>
  </button>
</ng-template>

<ng-template #sendToWaitingStatusButtonDispatched>
  <div class="btnSpacerCol" *ngIf="invoiceForm && !hidePDFViewerButtonForPPR">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Mettre la facture en attente" (click)="openWaitingStatusDialog()"
      [disabled]="hasMandatoryFieldChanged || isDispatchedWaitingDisabled">
      <mat-icon>hourglass_empty</mat-icon>
      <span class="long-btn-span currentBtnDetailColor" fxHide fxShow.gt-lg>Mise en attente</span>
    </button>
  </div>
  <div class="btnSpacerCol" *ngIf="!invoiceForm && !hidePDFViewerButtonForPPR">
    <button color="primary" mat-stroked-button class="currentBtnColor" matTooltip="Mettre la facture en attente" (click)="openWaitingStatusDialog()" [disabled]="!canWaitInvoiceInternal || !asRefOne">
      <mat-icon>hourglass_empty</mat-icon>
      <span class="long-btn-span currentBtnDetailColor" fxHide fxShow.gt-lg>Mise en attente</span>
    </button>
  </div>
</ng-template>

<ng-template #sendToWaitingStatusButtonControl>
  <div class="btnSpacerCol" *ngIf="invoiceForm">
    <button color="primary" mat-stroked-button class=" currentBtnColor" matTooltip="Mettre la facture en attente" (click)="openWaitingStatusDialog()" [disabled]="isControlWaitingDisabled">
      <mat-icon>hourglass_empty</mat-icon>
      <span class="long-btn-span currentBtnDetailColor" fxHide fxShow.gt-lg *ngIf="hasMandatoryFieldChanged">Enregistrer et mise en attente</span>
      <span class="long-btn-span currentBtnDetailColor" fxHide fxShow.gt-lg *ngIf="!hasMandatoryFieldChanged">Mise en attente</span>
    </button>
  </div>
  <div class="btnSpacerCol" *ngIf="!invoiceForm">
    <button color="primary" mat-stroked-button class=" currentBtnColor" matTooltip="Mettre la facture en attente" (click)="openWaitingStatusDialog()" [disabled]="!asRefOne">
      <mat-icon>hourglass_empty</mat-icon>
      <span class="long-btn-span large currentBtnDetailColor" fxHide fxShow.gt-lg *ngIf="hasMandatoryFieldChanged">Enregistrer et mise en attente</span>
      <span class="long-btn-span currentBtnDetailColor" fxHide fxShow.gt-lg *ngIf="!hasMandatoryFieldChanged">Mise en attente</span>
    </button>
  </div>
</ng-template>